<!-- Mikrotik Devices -->
<span>
  <ng-template #affixTemplate let-row>
    <app-card-table-actions [row]="row" [actions]="cdrRowActions" (actionEvent)="onCdrAction($event)" [breakpoint]="ScreenSize.TABLET"></app-card-table-actions>
  </ng-template>

  <app-generic-table-header [config]="headerOptions" (refreshEvent)="refreshTable($event)"></app-generic-table-header>

  @if (firstLoad && loadingCDRDevices) {
  <div class="mauto text-center">
    <br />
    <br />
    <br />
    <br />
    <mat-spinner class="spinner mauto" name="crescent"></mat-spinner>
    <br />
    <br />
  </div>
  } @if (data != null && data.length > 0) {
  <app-card-table
    #CDRTable
    [tableHeaders]="keepAliveTableHeaders"
    [data]="data"
    [currentPage]="currentCDRPage"
    [totalItems]="totalCdrDevices"
    [options]="cdrTableOptions"
    [enableInfiteScroll]="false"
    [enableTablePagination]="true"
    [affixTemplate]="affixTemplate"
    (paginateEvent)="getPagedDevices($event)"
    [breakpoint]="ScreenSize.TABLET"
    [enableRefresher]="true"
    (dataRefreshedEvent)="refreshData($event)"
  >
  </app-card-table>
  } @if ((data == null || data.length == 0) && !loadingCDRDevices) {
  <p class="text-align-center">No results were found.</p>
  }

  <ng-template #sticky> </ng-template
></span>
